import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../Controls/MessageHandler.component';
import {BlockComponent} from '../Controls/Block.component';


@Component({
  selector: 'my-equipment-grid',
  templateUrl: './EquipmentGrid.component.html'
})
export class EquipmentGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    salesOfficeCode: string;
    customerNumber: string;
    customerNameStartsWith: string;
    serialNumber: string;
    manufacturerSerialNumber: string;
    equipmentNumber: string;
    take: number = 1000;

    searchInfoText: string;
    
    @Input() showSearch: boolean = true;
    @Input() showSalesOfficeCode: boolean = true;
    @Input() showCustomerName: boolean = true;
    @Input() showCustomerNumber: boolean = true;
    @Input() showEquipmentGraphics: boolean = true;
    @Input() showEquipmentClass: boolean = true;
    @Input() showProcessedByRequest: boolean = false;
    @Input() showCheckboxSelectorColumn: boolean;
    @Input() showRadioSelectorColumn: boolean;
    
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;

    records: ent.Equipment[];
    selectedRecords: ent.Equipment[] = [];
    selectedRecord: ent.Equipment;
    
    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, private equipmentService: serv.EquipmentService) 
    { 
      

    }

    ngOnInit(): void {

        this.userInfo = this.authenticationService.getUserInfo();
        this.searchInfoText = `Note: For optimal performance, the search results will be limited to the first ${this.take} records. For more exact results, specify additional search criteria.`;
        
    }

    load(filter: filters.EquipmentFilter, equipmentNumbersToSelect: string[]): void {

        this.blockComponent.blocked = true;
        this.equipmentService.getEquipments(filter).subscribe(x=> {
            this.records = x;

            this.selectedRecords = [];
            for (var equipNbr of equipmentNumbersToSelect) {
                //var equip = this.records.filter(x=>x.EquipmentNumber == equipNbr)[0];
                var equips = this.records.filter(x=>x.EquipmentNumber == equipNbr);
                for (var equip of equips) {
                    if (equip) {
                        var existingSelectedRecord = this.selectedRecords.filter(x=>x.ID == equip.ID)[0];
                        if (!existingSelectedRecord){
                            this.selectedRecords.push(equip);
                        }
                    }
                }
            }
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        }); 

    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        var filter: filters.EquipmentFilter = {
            SalesOfficeCode: this.salesOfficeCode,
            CustomerNumber: this.customerNumber,
            CustomerNameStartsWith: this.customerNameStartsWith,
            SerialNumber: this.serialNumber, 
            ManufacturerSerialNumber: this.manufacturerSerialNumber,
            EquipmentNumber: this.equipmentNumber,
            Take: this.take
        };
        
        
        this.equipmentService.getEquipments(filter).subscribe(x=>{
            this.records = x;
            this.selectedRecords = [];
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;

        });
    }

    onRowSelect(event: any) {
        this.selectedRecord = event.data;
    }

    canSelect(item: ent.Equipment) : boolean {
        if (item.ProcessedByRequest != undefined){
            return false;
        }
        return true;
    }

    canSelectAny(): boolean{
        if (this.records == undefined){
            return false;
        }
        var items = this.records.filter(x=>x.ProcessedByRequest == undefined);
        return items.length > 0;
    }
    
}
    